import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  GA_BUTTON_STICKY_TOP_CLOSE_ACTION,
  GA_BUTTON_STICKY_TOP_DOWNLOAD_ACTION,
} from '../../../../containers/home/domain/store/HomeStoreEn';
import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import { useStickyVisibilityContext } from '../../../../contexts/sticky-visibilty-context/StickyVisibilityContext';
import NextImageV2 from '../../../../ui/components/NextImageV2';
import { getStickyDownloadLink } from '../helpers/StickyDownloadLink';
import styles from '../styles/DownloadApp.module.scss';
import { OpenAppContent } from '../vm/HeaderVm';

interface DownloadAppCmpProps {
  data: OpenAppContent;
}

function DownloadAppCmp({
  data,
}: Readonly<DownloadAppCmpProps>): React.ReactElement | null {
  const router = useRouter();
  const { isStickyHidden } = useStickyVisibilityContext();
  const citySelectedContext = useCitySelectedContext();
  const [isClosed, setIsClosed] = useState(false);
  const { app_action, card, close_icon } = data;

  const publishStickyEvent = (category: string, action: string): void => {
    publishGa4Events(category, action, uuidv4());
  };

  const downloadLink = (): string =>
    getStickyDownloadLink(
      router.asPath,
      citySelectedContext.city_selected,
      router.pathname,
    );

  const handleDownloadClick = (): void => {
    publishStickyEvent(
      citySelectedContext.category,
      GA_BUTTON_STICKY_TOP_DOWNLOAD_ACTION,
    );
    globalThis.location.href = downloadLink();
  };

  const handleClose = (): void => {
    setIsClosed(true);
    publishStickyEvent(
      citySelectedContext.category,
      GA_BUTTON_STICKY_TOP_CLOSE_ACTION,
    );
  };

  if (isClosed) {
    return null;
  }

  return (
    <div
      className={`${styles['wrapper']} ${isStickyHidden ? styles['hidden'] : ''}`}
    >
      <div className={styles['container']}>
        <div className={styles['logo']}>
          <NextImageV2
            src={card.icon.path}
            alt={card.icon.alt_text}
            height={40}
            width={40}
            quality={100}
          />
        </div>
        <div className={styles['title-subtitle']}>
          <div className={styles['title']}>{card.title}</div>
          <div className={styles['sub-title']}>{card.desc}</div>
        </div>
        <button
          id="download-button-link"
          className={styles['download-button']}
          onClick={handleDownloadClick}
        >
          <Link
            href={app_action.link}
            className={styles['download-button-text']}
          >
            {app_action.label}
          </Link>
        </button>
        <button className={styles['hide-button']} onClick={handleClose}>
          <NextImageV2
            src={close_icon.path}
            alt="hide"
            height={12}
            width={12}
            quality={100}
          />
        </button>
      </div>
    </div>
  );
}

export default DownloadAppCmp;
